import rpcClient from 'ContentEditorUI/api/RpcClient';
import { getPortalAssetVersionInfoRpc } from 'ContentEditorUI/__generated__/chirp/com/hubspot/cms/asset/versions/rpc/ModuleUpdateRpc';
export const fetchModuleVersions = templatePath => {
  return rpcClient.call(getPortalAssetVersionInfoRpc, {
    request: {
      templatePath
    }
  });
};